const unwrapMentionBlot = (Embed) => {
    class Mention extends Embed {
        static create(value) {
            const node = super.create(value);
            node.setAttribute('spellcheck', false);
            node.textContent = `@${value}`;

            return node;
        }

        static formats(domNode) {
            return domNode.getAttribute('name');
        }

        static value(domNode) {
            return domNode.textContent;
        }
    }
    Mention.blotName = 'mention';
    Mention.className = 'editor-mention-user';
    Mention.tagName = 'span';

    return Mention;
};

export default unwrapMentionBlot;
